<template>
    <div class="anchor" ref="anchor">
        <div
            v-for="item in params"
            :key="item.id"
            @click.prevent="handleScrollTo(item)"
            :class="{anchorActive: currentActive === item.id}"
        >
            {{item.itemName}}
        </div>
    </div>
</template>

<script>
/**
 * @file
 * @author
 */
import {on, off, scrollTop} from 'js/Utils';
import {get} from 'lodash';

export default {
    data() {
        return {
            animating: false,
            scrollContainer: null,
            offsetArr: [],
            currentActive: ''
        };
    },
    props: {
        container: null,
        params: {
            type: Array,
            default: () => []
        },
        duration: {
            type: Number,
            default: 500
        },
        anchorClass: {
            type: String,
            default: ''
        },
        anchorTag: {
            type: String,
            default: 'div'
        },
        firstTop: {
            type: Boolean,
            default: false
        },
        refresh: {
            type: Number | undefined,
            default: undefined
        },
        top: Number
    },
    mounted() {
        this.init();
        on(window, 'resize', this.init);
    },
    deactivated() {
        off(this.scrollContainer, 'scroll', this.handleScroll);
        off(window, 'resize', this.init);
    },
    watch: {
        params() {
            this.init();
        },
        container() {
            this.init();
        },
        refresh() {
            this.init();
        }
    },
    methods: {
        handleScrollTo(item) {
            // const ele = this.offsetArr.find(ele => ele.anchor === item.id);
            const eleIdx = this.offsetArr.findIndex(ele => ele.anchor === item.id);
            const ele = this.offsetArr[eleIdx];
            if (ele !== undefined) {
                this.animating = true;
                this.currentActive = item.id;
                let currScrollTop;
                if (this.scrollContainer === window) {
                    currScrollTop = document.documentElement.scrollTop
                        || document.body.scrollTop;
                }
                else {
                    currScrollTop = this.scrollContainer.scrollTop;
                }
                scrollTop(
                    this.scrollContainer,
                    currScrollTop,
                    ele.offset,
                    this.duration,
                    () => {
                        this.animating = false;
                    }
                );
                this.$emit('clickitem', item, eleIdx);
            }
        },
        handleScroll() {
            if (this.animating) {
                return;
            }
            let currScrollTop;
            if (this.scrollContainer === window) {
                currScrollTop = document.documentElement.scrollTop
                    || document.body.scrollTop;
            }
            else {
                currScrollTop = this.scrollContainer.scrollTop;
            }
            this.getCurrentScrollTop(currScrollTop);
        },
        getCurrentScrollTop(scrollTop) {
            for (let i = 0; i < this.offsetArr.length; i++) {
                let currEle = this.offsetArr[i];
                let nextEle = this.offsetArr[i + 1];
                if (
                    scrollTop >= currEle.offset
                    && scrollTop < ((nextEle && nextEle.offset) || Infinity)
                    && this.currentActive !== currEle.anchor
                ) {
                    this.currentActive = currEle.anchor;
                    const anchorItem = get(this.$refs.anchor, `children[${i}]`, undefined);
                    if (anchorItem) {
                        this.$refs.anchor.scrollTop = anchorItem.offsetTop;
                    }
                    break;
                }
            }
        },
        getContainer() {
            const scrollContainer = this.container
                ? (typeof this.container === 'string'
                    ? document.querySelector(this.container)
                    : this.container)
                : window;
            this.scrollContainer = scrollContainer;
            return scrollContainer;
        },
        updateOffset() {
            let offsetArr = [];
            let firstOffsetTop = void 233;
            (document.querySelectorAll(
                `${this.anchorTag}${this.anchorClass}[data-type=\'anchor\']`
            ) || [])
                .forEach(ele => {
                    const anchor = ele.dataset.anchor;
                    if (!anchor) {
                        return;
                    }
                    if (firstOffsetTop === void 233) {
                        firstOffsetTop = this.firstTop ? 0 : ele.offsetTop;
                    }
                    offsetArr.push({
                        anchor,
                        offset: ele.offsetTop - firstOffsetTop - (this.top || 0)
                    });
                });
            if (this.firstTop) {
                offsetArr[0].offset = 0;
            }
            this.offsetArr = offsetArr;
        },
        init() {
            this.currentActive = get(this.params, '[0].id', '');
            this.$nextTick(() => {
                const scrollContainer = this.getContainer();
                this.updateOffset();
                this.handleScroll();
                on(scrollContainer, 'scroll', this.handleScroll);
            });
        }
    }
};
</script>

